import JobSelectModal from '@pc/components/Works/Panel/SelectModal/JobSelectModal'
import ButtonGroup from '@pc/components/Works/Panel/shared/Button/ButtonGroup'
import ConditionParagraph from '@pc/components/Works/Panel/shared/ConditionParagraph'
import EmphasisHeading from '@pc/components/Works/Panel/shared/Heading/EmphasisHeading'
import type { SearchParamsAttributes, ConditionReducer } from '@pc/components/Works/Panel/types'
import buildConditionWords from '@pc/components/Works/Panel/utils/buildConditionWords'
import BaseSelectPanel from './BaseSelectPanel'

interface PropsType {
  params: SearchParamsAttributes
  conditionReducer: ConditionReducer
}

const JobSelectPanel = (props: PropsType) => {
  const { params, conditionReducer } = props
  const jobTitles = [conditionReducer.attributes.condition_title_maps.job_codes, conditionReducer.attributes.condition_title_maps.job_type_ids]
    .flat()
    .filter((v): v is string => v != null)

  return (
    <BaseSelectPanel>
      <EmphasisHeading>職種</EmphasisHeading>
      <ConditionParagraph>{buildConditionWords(jobTitles)}</ConditionParagraph>
      <ButtonGroup>
        <JobSelectModal params={params} />
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default JobSelectPanel
